import {
  extractPreciseXrefs,
  scrollToXrefByKey,
} from "../../Utility/FrontMatterList";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";

const SuperScript = ({ visible, editor, editRef, onClose }) => {
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [xrefs, setXrefs] = useState([]);
  const buttonWrapperRef = useRef(null);

  const handleCheckboxChange = (key) => {
    setSelectedKeys((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  const handleNumberClick = (e, key) => {
    e.preventDefault();
    e.stopPropagation();
    scrollToXrefByKey(editRef, key);
  };

  const handleSubmit = () => {
    if (!editor || !selectedKeys.length) return;

    const dom = editor.dom;
    const main = dom.select("body1")[0];

    selectedKeys.forEach((key) => {
      const xref = main.querySelector(`xref[key="${key}"]`);
      if (xref) {
        const parent = xref.parentNode;
        const prev = xref.previousSibling;
        const next = xref.nextSibling;

        // Remove leading bracket like " ["
        if (prev && prev.nodeType === 3 && /\[\s*$/.test(prev.textContent)) {
          prev.textContent = prev.textContent.replace(/\[\s*$/, "");
        }

        // Remove trailing bracket like "] "
        if (next && next.nodeType === 3 && /^\s*\]/.test(next.textContent)) {
          next.textContent = next.textContent.replace(/^\s*\]/, "");
        }

        // Set xref content and apply superscript styling
        const number = xref.textContent.trim();
        dom.setHTML(xref, number);
        dom.setStyles(xref, {
          verticalAlign: "super",
          fontSize: "medium",
          cursor: "pointer",
          padding: "0 5px 0 0",
        });
      }
    });
    toast.success("Citations Changed");
    onClose(); // Optional
  };

  useEffect(() => {
    if (editor) {
      const response = extractPreciseXrefs(editor);
      setXrefs(response);
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!editor) return;
      if (!buttonWrapperRef.current) return;
      const clickedInsideAnyXrefBox = buttonWrapperRef.current.contains(
        event.target
      );

      if (!clickedInsideAnyXrefBox) {
        const highlighted = editor.dom.select("xref.highlighted-xref");
        if (highlighted.length > 0) {
          editor.dom.removeClass(highlighted, "highlighted-xref");
        }
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit();
      }}
    >
      {/* Scrollable content inside form */}
      <div className="border-b border-grey p-3 absolute top-0 bg-leftPanelbg inset-x-0 ">
        <h4 className="font-semibold text-primary text-[18px]">Citations To SuperScript</h4>
      </div>
      <div className="space-y-3 mt-12 pb-4">
    
        <div className="flex items-center gap-2  justify-end">
          <span className="font-medium text-[15px]">Select All</span>
          <input
            type="checkbox"
            className="w-[14px] h-[14px] cursor-pointer"
            checked={selectedKeys.length === xrefs.length && xrefs.length > 0}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedKeys(xrefs.map((x) => x.key));
              } else {
                setSelectedKeys([]);
              }
            }}
          />
        </div>
        {/* </div> */}
        {/* Xrefs List */}
        <div className="max-h-[calc(100%-76px)] min-h-[200px] overflow-y-auto  space-y-3">
          {xrefs.length > 0 ? (
            xrefs.map((xref, index) => (
              <div
                ref={buttonWrapperRef}
                key={xref.key}
                className="flex justify-between gap-2 bg-white items-center border p-2 rounded hover:bg-gray-50"
              >
                <div className="flex items-start">
                  <input
                    type="checkbox"
                    className="cursor-pointer mt-[8px] "
                    checked={selectedKeys.includes(xref.key)}
                    onChange={() => handleCheckboxChange(xref.key)}
                  />
                  <span className="px-4">
                    {
                      xref.beforeText.length > 60
                        ? `${xref.beforeText
                            .replace(/^[\]\[.\s]+/, "") // clean start
                            .replace(/[\]\[.\s]+$/, "") // clean end
                            .slice(0, 60)}...`
                        : xref.beforeText
                            .replace(/^[\]\[.\s]+/, "") // clean start
                            .replace(/[\]\[.\s]+$/, "") // clean end
                    }
                  </span>
                </div>
                <button
                  type="button"
                  onClick={(e) => handleNumberClick(e, xref.key)}
                  className="text-blue-600 hover:underline min-w-fit"
                >
                  [{xref.number}]
                </button>
              </div>
            ))
          ) : (
            <>
              <h4 className="text-center text-[18px] w-full mb-5 ">
                No Citations Available
              </h4>
            </>
          )}
        </div>
      </div>

      <div className="flex justify-end gap-4  py-2 px-2 absolute bg-leftPanelbg bottom-0  inset-x-0 ">
        <button
          type="button"
          onClick={onClose}
          className="bg-gray-200 px-4 py-[4px] rounded hover:bg-gray-300"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="bg-hovergrey text-white px-4 py-[4px] rounded hover:bg-primary"
        >
          Submit
        </button>
      </div>
    </form>
  );
};

export default SuperScript;
